import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  action?: React.ReactNode;
}
export function Card({
  children,
  className = '',
  title,
  action
}: CardProps) {
  return <div className={`bg-white rounded-lg border border-gray-200 shadow-sm ${className}`} data-id="element-64">
      {(title || action) && <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center" data-id="element-65">
          {title && <h3 className="text-lg font-medium text-gray-900" data-id="element-66">{title}</h3>}
          {action && <div data-id="element-67">{action}</div>}
        </div>}
      <div className="p-6" data-id="element-68">{children}</div>
    </div>;
}